import React from 'react';
import "./logo.css";

function AboutMe(){
	return (
		<section className="about__me section" id="about__me" name="about__me" style={{paddingTop: '3rem'}}>
			<div className="container">
				<div className="mt-4 centered"></div>
					<div className="pages__HeadingImage-sc-6kvjaa-6 dRJBUI"></div>
						<div style={{alignItems: 'start', margin: '0px', justifyContent: 'space-between'}} className="pages__Container-sc-6kvjaa-0 gOEfjj">
							<div className="pages__TextContent-sc-6kvjaa-3 pages__TextContentWrap-sc-6kvjaa-4 bIuuIZ">
								<p className="Paragraph-sc-1tzuhix-0">
									I have the qualification in BSc in Computer Science and apart of the qualification that i possess i have accumulated a wealth of exposure and experience from my current employment.
									<br/><br/>As I've grown as a developer, I've worked alongside senior designers and developers who have raised my standards for whats expected of any web application.
								</p>
							</div>
								<div className="pages__TextContent-sc-6kvjaa-3 pages__TextContentWrap-sc-6kvjaa-4 bIuuIZ">
									<p className="Paragraph-sc-1tzuhix-0">
										Through these experiences, I've had the opportunity to create memorable products that are not only enjoyable to use but are written in code that's maintainable and easy to understand.
									</p>
								</div>
						</div>
			</div>
		</section>
	);
}
export default AboutMe;